function splitHtmlIntoParagraphs(htmlString) {
  // 1. Create a temporary container element
  const container = document.createElement('div');
  // Trim whitespace around the string which might become text nodes
  container.innerHTML = htmlString.trim();

  // 2. Get all direct child elements of the container
  //    (Assuming the paragraphs are the direct children, like in your example)
  const children = container.children;

  // 3. Initialize an array to hold the paragraph HTML strings
  const paragraphsArray = [];

  // 4. Loop through the child elements and get their outerHTML
  for (let i = 0; i < children.length; i++) {
    // Ensure we are only adding actual paragraph elements if needed,
    // though .children should only return elements anyway.
    if (children[i].tagName === 'P') {
      paragraphsArray.push(children[i].outerHTML);
    }
    // If you might have other top-level tags you also want to include,
    // you could remove the if condition:
    // paragraphsArray.push(children[i].outerHTML);
  }

  return paragraphsArray;
}

export { splitHtmlIntoParagraphs };
